/**
 * DASH-3340: mirrors the BE `DistributionPlotUnavailableReason` enum
 * (Web.Api.Core/Domain/Enums/DistributionPlotUnavailableReason.cs). Names the data
 * condition that stopped a Risk Register's distribution (Q-Q / log-normal PDF) plots
 * from being drawn on the read path, so the FE can render the actual reason instead of
 * inferring it. Recomputed on every read and NEVER persisted, so — unlike
 * `NonDetectExclusionEffect` — these values carry no storage contract and the set may
 * grow. Values start at 1 so `default(enum)` cannot masquerade as a real reason; `null`
 * on the register means the plots were produced.
 */
export enum DistributionPlotUnavailableReason {
    /** No OEL was resolved, or it was non-positive — reference lines and exceedance statistics have no basis. */
    OelUnavailable = 1,
    /** Fewer than the three-sample floor required to fit a distribution. */
    InsufficientSamples = 2,
    /** The statistical set contains a non-positive value: Math.Log(0) is undefined, so the fit is rejected. */
    NonPositiveValue = 3,
    /** Zero variance — every value in the statistical set is identical, so there is no distribution to plot. */
    ZeroVariance = 4,
}
